import axios from 'axios';
import {getTimezoneCode} from '../helpers/getTimezoneCode'; 

const api = axios.create({
  baseURL: process.env.REACT_APP_BACKEND_URL,
  withCredentials: true,
});

api.interceptors.request.use(
  (config) => {
    const timezone = localStorage.getItem("timezone") || getTimezoneCode();
        
    config.headers.timezone = timezone;

    // Axios 0.21 defaults POST Content-Type to x-www-form-urlencoded; remove for FormData
    // so the browser can set multipart boundary (critical on Chrome Android).
    if (typeof FormData !== "undefined" && config.data instanceof FormData) {
      if (config.headers) {
        delete config.headers["Content-Type"]
        delete config.headers["content-type"]
      }
      if (config.headers?.post) {
        delete config.headers.post["Content-Type"]
      }
      if (api.defaults.headers?.post) {
        delete api.defaults.headers.post["Content-Type"]
      }
    }

    return config; 
  },
  (error) => {
    console.error('Request error:', error);
    return Promise.reject(error);
  }
);

export const openApi = axios.create({
  baseURL: process.env.REACT_APP_BACKEND_URL,
});

export default api;